<template>
  <div>
    <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="800">
      <a-form-model ref="channelForm" :model="channel" :rules="rules" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Business" prop="businessId">
              <a-select placeholder="Business" v-model="channel.businessId" style="width: 100%">
                <a-select-option v-for="business in businesses" :key="business.id" :value="business.id">
                  {{ business.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Channel name" prop="name">
              <a-input placeholder="Channel Name" v-model="channel.name" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <template #footer>
        <a-button type="primary" @click="save" :loading="isSaving">Save</a-button>
        <a-button @click="cancel">Cancel</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import ModalMixin from '../Common/Mixins/modalMixin';
import { channelMutations } from '../../Store/store';

export default {
  props: {
    channel: {
      type: Object,
      default: () => ({}),
    },
    businesses: { type: Array, default: () => [] },
  },
  mixins: [ModalMixin],
  data() {
    return {
      rules: {
        name: [{ required: true, message: 'Please input a channel name!', trigger: 'blur' }],
        businessId: [{ required: true, message: 'Business is required!', trigger: 'blur' }],
      },
      isSaving: false,
    };
  },
  computed: {
    addChannelSuccess() {
      return  `Channel ${this.mode == this.modes.edit ? 'updated' : 'added'} successfully!`;
    }
  },
  methods: {
    save() {
      this.$refs.channelForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;
          try {
            if (this.mode == this.modes.edit) {
              await channelMutations.updateChannel(this.channel);
            } else {
              await channelMutations.addChannel(this.channel);
            }
            this.$message.success(this.addChannelSuccess);
            this.visible = false;
          } catch (error) {
            this.$message.error(error.response?.data?.errors[0]?.message ?? error.message);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
};
</script>